import React, { useEffect } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { ServiceSection } from './components/ServiceSection';
import { Testimonials } from './components/Testimonials';
import { InfoFooter } from './components/InfoFooter';
import { TawkChat } from './components/TawkChat';
import { SectionFade } from './components/ui/SectionFade';
const RED = '#e10600';
const INK = '#111111';
const COSMIC = '#0b0614';
const LIGHT = '#f5f5f4';
const PAGE_TITLE = 'Amarres y Encantamientos de Amor | Consulta Espiritual';
const PAGE_DESCRIPTION = 'Amarres y encantamientos de amor, videncia y orientación espiritual con más de 21 años de experiencia. Consulta inicial sin costo.';

/** Overwrites any leftover template metadata so crawlers read the real copy */
function setMeta(selector: string, attr: 'name' | 'property', key: string) {
  let tag = document.head.querySelector<HTMLMetaElement>(selector);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  return tag;
}
export function App() {
  useEffect(() => {
    document.title = PAGE_TITLE;
    document.documentElement.lang = 'es';
    setMeta('meta[name="description"]', 'name', 'description').content = PAGE_DESCRIPTION;
    setMeta('meta[property="og:title"]', 'property', 'og:title').content = PAGE_TITLE;
    setMeta('meta[property="og:description"]', 'property', 'og:description').content = PAGE_DESCRIPTION;
    setMeta('meta[name="twitter:title"]', 'name', 'twitter:title').content = PAGE_TITLE;
    setMeta('meta[name="twitter:description"]', 'name', 'twitter:description').content = PAGE_DESCRIPTION;

    // Remove stale template metadata that ad platforms may still scrape
    document.head.querySelectorAll('meta[name="keywords"], meta[name="author"]').forEach(tag => tag.remove());
  }, []);
  return <div className="w-full bg-brand-ink" data-id="element-0" data-mp="swgkxqawp4q6">
      <Header data-id="element-1" data-mp="35ox2qy1z4t4" />

      <main data-id="element-2" data-mp="356sn718lka4">
        <Hero data-id="element-3" data-mp="34x29ica5b3w" />
        <SectionFade from={INK} to={RED} data-id="element-4" data-mp="38kvegdtbvi3" />

        <ServiceSection id="amarres-de-amor" tone="red" reverse eyebrow="Maestros Espirituales" title="AMARRES DE AMOR FUERTES" body="Realizamos trabajos de amarres para fortalecer la conexión con la persona amada, sin distinción de orientación. Mereces vivir una relación plena y feliz." image="https://cdn.magicpatterns.com/patterns/generated-images/a5114d62-0619-47c1-b0ae-d0a624dd368e.jpg" imageAlt="Manos sosteniendo un corazón de cera rojo sobre un papel antiguo" showContactInline data-id="element-5" data-mp="3udazyhcy738x" />
        <SectionFade from={RED} to={INK} data-id="element-6" data-mp="3lkr2vlcb16q7" />

        <ServiceSection id="encantamientos" tone="dark" title="ENCANTAMIENTOS DE AMOR" body="Con hechizos orientados en la magia blanca, negra y roja, buscamos transmitir energía positiva para fortalecer el amor verdadero, mejorar la conexión de pareja y atraer armonía a la relación." image="https://cdn.magicpatterns.com/patterns/generated-images/b9edeb28-0083-4b34-bcfb-b618869aa0f9.jpg" imageAlt="Corazones de cera sobre una carta antigua junto a una vela encendida" data-id="element-7" data-mp="3liwkoesf3spt" />
        <SectionFade from={INK} to={RED} data-id="element-8" data-mp="13eodk99rx54s" />

        <ServiceSection id="mismo-sexo" tone="red" reverse title="AMARRES DE AMOR DEL MISMO SEXO" body="Ofrecemos amarres inclusivos para todo tipo de parejas, acompañamiento espiritual para reconectar con la persona amada, sin importar el género." image="https://cdn.magicpatterns.com/patterns/generated-images/602a8dba-62b8-405c-92db-a149113a62ff.jpg" imageAlt="Pareja del mismo sexo abrazada envuelta en una bandera del orgullo" data-id="element-9" data-mp="13fg95k3df2v2" />
        <SectionFade from={RED} to={COSMIC} data-id="element-10" data-mp="6mujozefwchl" />

        <ServiceSection id="videncia" tone="cosmic" title="VIDENCIA Y CONSULTA ESPIRITUAL" body="Recibe orientación de nuestros especialistas y descubre el camino hacia el bienestar espiritual y personal." footnote="Consulta inicial sin costo." image="https://cdn.magicpatterns.com/patterns/generated-images/ac47c8f0-6051-47d6-a9aa-ed3e3da52f3b.jpg" imageAlt="Altar con velas moradas y un pentagrama de ramas sobre una superficie brillante" data-id="element-11" data-mp="apr6z3excwrv" />
        <SectionFade from={COSMIC} to={LIGHT} data-id="element-12" data-mp="19w9n10ino5yz" />

        <Testimonials data-id="element-13" data-mp="19tx70swgk5ok" />
        <SectionFade from={LIGHT} to={INK} data-id="element-14" data-mp="14wwymbc4yqua" />

        <InfoFooter data-id="element-15" data-mp="14y836ddeo2mg" />
      </main>

      <TawkChat data-id="element-16" data-mp="14v3sqy9ckanc" />
    </div>;
}